// src/components/common/Badge.jsx
import React from 'react';

/**
 * Micro-Affordance Badge & Eyebrow Tag
 * - Pill shape with hairline border and inner highlight
 * - Status indicator with optional animated pulsing dot
 */
export default function Badge({
  children,
  variant = 'neutral', // 'neutral' | 'live' | 'indigo' | 'cyan' | 'warning' | 'danger'
  size = 'md',        // 'sm' | 'md'
  pulsing = false,
  className = '',
  ...rest
}) {
  const isLive = variant === 'live' || pulsing;

  return (
    <span className={`badge badge--${variant} badge--${size} ${className}`} {...rest}>
      {isLive && (
        <span className="badge__pulse-dot" aria-hidden="true">
          <span className="badge__pulse-ring" />
        </span>
      )}
      <span className="badge__label">{children}</span>
    </span>
  );
}
